<template>
  <div
    v-if="count > 0"
    class="color-slate-600 inline-flex items-center py-1 font-medium"
  >
    {{ count }} {{ count === 1 ? noun.singular : noun.plural }} geselecteerd
  </div>
</template>

<script setup lang="ts">
// Status-bar panel shared by AppDataGrid and AppLocalGrid: a crisp "N verkooporderregels geselecteerd"
// count, shown only while something is selected. Each form resolves independently as override → translated
// entity name → generic: the `singular`/`plural` params (from the grid's props) win; otherwise the grid's
// translated entity name (`entities.<resourceKey>` / `entities.plural.<resourceKey>`), resolved reactively
// so it fills in once translations have loaded; else regel/regels.
import { translate } from "~/plugins/I18n.ts";

const props = defineProps<{ params: any }>();

const count = ref(0);
const api = props.params.api;
const update = () => (count.value = api.getSelectedRows().length);

api.addEventListener("selectionChanged", update);
update();

onUnmounted(() => api.removeEventListener("selectionChanged", update));

const noun = computed(() => {
	const { singular, plural, resourceKey } = props.params;

	let translatedSingular: string | undefined;
	let translatedPlural: string | undefined;
	if (resourceKey) {
		const singularKey = `entities.${resourceKey}`;
		const pluralKey = `entities.plural.${resourceKey}`;
		const s = translate(singularKey);
		const p = translate(pluralKey);
		// vue-i18n returns the key itself when it is missing.
		if (s !== singularKey) translatedSingular = s.toLowerCase();
		if (p !== pluralKey) translatedPlural = p.toLowerCase();
	}

	return {
		singular: singular ?? translatedSingular ?? "regel",
		plural: plural ?? translatedPlural ?? "regels",
	};
});
</script>
